import * as Nav from "../layout/nav";

let petrobarEl;
let petrobarItemEl;

document.addEventListener("DOMContentLoaded", () => {
  petrobarEl = document.querySelector(".js-app-nav-petrobar");
  if (petrobarEl === null) return;

  petrobarItemEl = document.querySelector(".js-app-nav-petrobar-mobile");
  petrobarItemEl.addEventListener("click", () => toggle());
});

/**
 * Open the petrobar on mobile and tablet devices. This function has
 * no effect on desktop devices.
 */
export function open() {
  toggle(true);
}

/**
 * Close the petrobar on mobile and tablet devices. This function has
 * no effect on desktop devices.
 */
export function close() {
  toggle(false);
}

function toggle(force = undefined) {
  const isOpen = petrobarEl.classList.toggle("has-flex", force);
  Nav.toggleItemOpen(petrobarItemEl, isOpen);

  if (isOpen) {
    const clickOutsideListener = (event) => {
      if (petrobarEl.contains(event.target)) return;
      toggle(false);
      document.removeEventListener("click", clickOutsideListener);
    };
    requestAnimationFrame(() => {
      // Wait for the click event to propagate before adding the listener
      document.addEventListener("click", clickOutsideListener);
    });
  }

  return isOpen;
}

export function initForAlpine(Alpine) {
  Alpine.magic("petrobar", () => ({
    open,
    close,
  }));
}
